module.exports = __webpack_public_path__ + "img/logo-linear.631b41d0.svg";